declare var gtag: any;


export const trackClick = (eventName: string, params?: { }) => {
    if (!window.location.hostname.includes('localhost')) {
        gtag('event', `platform_${eventName}`, params);
    }
}
